<template>
	<div class="post">
		<div class="top animate__animated animate__fadeInDown">
			<img src="../../public/images/logo.png">
			<div class="write">让按摩变得简单</div>
			<a class="goBack" :href="url">打开看看</a>
		</div>
		<div>
			<div class="head">
				<img :src="HeadImg" class="headImage" />
				<div class="headInfo">
					<div class="name"><span>{{nickName}}</span></div>
					<div class="time">{{updateTime}}</div>
				</div>
			</div>
			<div class="content">
				<div class="title">{{title}}</div>
				<div class="contents" v-html="content">{{content}}</div>
				<div class="imgAry">
					<div @click="ShowImg(img)" :style=" 'background-image: url(' + img+ ');width:'+ (screenWidth *0.3) +'px;height:'+ (screenWidth *0.3) +'px;'"
					 style="margin-left: 3%; background-size: cover;" v-for="img in imgAry">
					</div>
				</div>
			</div>
			<div style="background-color: #ECECEC;height: 10px;width: 100%;margin-top: 20px;"></div>
			<div @click="clickA">
				<div class="allComments">全部评论</div>
				<div v-if="index < 6" v-for="(replys,index) in replysAry" class="comment">
					<img style="width: 40px;height: 40px;" :src="replys.headImage" />
					<div style="width: 80%;margin-left: 10px;">
						<div style="text-align: left;font-size: 20px;color: #509EE3;">{{replys.nickName}}</div>
						<div style="text-align: left;margin-top: 5px;">{{replys.comment}}</div>
						<div style="text-align: left;margin-top: 5px;font-size: 10px;font-weight: 200;">{{replys.createTime}}</div>
						<div class="commentAry">
							<div v-for="(rep,index) in replys.replyAry">
								<div v-if="index < 2">
									<a class="nameText">{{rep.nickName}}</a>
									:{{rep.comment}}
								</div>
							</div>
							<div class="nameText" v-if="replys.replyAry.length > 2">
								全部{{replys.replyAry.length}}条评论 >
							</div>
						</div>
					</div>
				</div>
				<div style="margin-top: 30px;margin-bottom: 30px;" v-if="replysAry.length > 6">
					<div style="font-size: 10px;">打开APP查看更多有趣动态</div>
				</div>
			</div>

		</div>
		<div @click="onShowImg" v-if="imgShow" style="display: flex; justify-content: center;align-items: center; background-color: rgba(0,0,0,0.2);position: fixed;left: 0;top:0; z-index: 101;width: 100%;"
		 :style="'height:' + windowHeight + 'px'">
			<img :src="ShowImgUrl" style="width: 80%;height: auto;" />
		</div>
		
		<div v-if="bgShow" style="display: flex; justify-content: center;align-items: center; background-color: #FFFFFF;position: absolute;left: 0;top:0; z-index: 101;width: 100%;"
		 :style="'height:' + windowHeight + 'px'">
			暂无此帖子
		</div>

	</div>


</template>

<script>
	import request from '../common/request.js'
	import axios from 'axios'

	export default {
		data() {
			return {
				screenWidth: document.body.clientWidth,
				screenHeight: document.body.clientHeight,
				windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
				windowHeight: document.documentElement.clientHeight, //实时屏幕高度
				HeadImg: '',
				nickName: '',
				updateTime: '',
				title: '',
				content: '',
				replysAry: [],
				ID: '',
				url: 'lfwellness://',
				imgAry: [],
				imgShow: false,
				ShowImgUrl: '',
				bgShow:false
			}
		},
		created() {
			let that = this;
			that.ID = window.location.href.split("=")[1]
			let data = {
				"out_id": that.ID,
			}
			let requests = request.getQueryData(data || {})
			axios.post('/api_app/v2/bbspublic/share',
				requests).then(function(data) {
				console.log("data", data);
				if (data.data.ResultCode == 200) {
					that.HeadImg = data.data.data.image_path
					that.nickName = data.data.data.nick_name
					that.updateTime = data.data.data.update_time
					that.title = data.data.data.title
					that.content = data.data.data.content
					let id = data.data.data.bbs_id
					that.url = 'lfwellness://' + id + '//post'
					let imgAry = []
					for (let img of data.data.data.b_to_file) {
						imgAry.push(img.path)
					}
					that.imgAry = imgAry;

					for (let replys of data.data.data.b_to_bcm) {

						let replyAry = []

						for (let reps of replys.bcm_to_bcm) {
							let rep = {
								nickName: reps.nick_name,
								headImage: reps.head_image,
								createTime: reps.create_time,
								comment: reps.comment
							}
							replyAry.push(rep)
						}


						let reply = {
							nickName: replys.nick_name,
							headImage: replys.head_image,
							createTime: replys.create_time,
							comment: replys.comment,
							replyAry: replyAry
						}
						that.replysAry.push(reply)
					}


				} else {
					// window.alert("获取失败,请重试!");
					that.bgShow = true
				}
			}).catch(function(err) {
				console.log('err', err);
			});
		},
		methods: {
			ShowImg(img) {
				this.imgShow = true
				this.ShowImgUrl = img
				document.documentElement.style.overflowY = "hidden";
			},
			onShowImg() {
				this.imgShow = false
				document.documentElement.style.overflowY = "auto";
			},
			clickA() {
				window.location.href = this.url; //  跳转链接
			}
		}
	}
</script>

<style scoped>
	@import url("../common/animate.min.css");

	.post {
		max-width: 33.75rem;
		height: 100%;
		position: relative;
		margin: 0 auto;
	}

	.post .top {
		width: 100%;
		height: 4rem;
		background-color: white;
		position: fixed;
		top: 0;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		z-index: 110;
		max-width: 33.75rem;
		background-color: rgba(0, 0, 0, 0.5);
	}

	.post .top img {
		width: 4rem;
		height: 4rem;
		margin-left: 1rem;
	}

	.post .top .write {
		width: 57%;
		color: #FFFFFF;
		font-size: 1rem;
		font-weight: 550;
		text-align: left;
		padding: 0.3rem 0 0 1rem;
	}

	.post .top .goBack {
		width: 5rem;
		height: 2rem;
		background-color: #04D09C;
		font-size: 0.9rem;
		color: rgb(255, 255, 255);
		text-decoration: none;
		text-align: center;
		line-height: 2rem;
		margin-right: 1rem;
		border-radius: 5px;
		/* margin-left: 30%; */
	}

	.post .head {
		width: 100%;
		margin-top: 4rem;
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.post .head .headImage {
		width: 3.75rem;
		height: 3.75rem;
		border-radius: 1.875rem;
		margin-left: 20px;
	}

	.post .head .headInfo {
		flex-direction: column;
		justify-content: flex-start;
		margin-left: 1rem;
/* 		align-items: center;
		justify-content: center;
		margin-left: 20px; */
	}
	.post .head .headInfo .name{
		text-align:left;
		font-weight: 600;
	}
/* 	.post .head .headImage .name{
		text-align:left;
		font-weight: 600;
	} */

	.post .head .headInfo .time {
		/* text-align: left; */
		width: 100%;
		margin: 0;
		font-size: 13px;
		color: #C2C2C2;
	}

	.post .content {
		margin-top: 20px;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.post .content .title {
		font-size: 25px;
		font-weight: 500;
	}

	.post .content .contents {
		margin-top: 10px;
		width: 90%;
		text-align: left;
		text-indent: 2em;
	}

	.post .content .imgAry {
		margin-top: 10px;
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
	}

	.post .comment {
		display: flex;
		flex-direction: row;
		width: 90%;
		margin-left: 5%;
		margin-top: 20px;
	}

	.post .comment .commentAry {
		text-align: left;
		margin-top: 5px;
		background-color: #F0F0F0;
		border-radius: 5px;
	}

	.post .nameText {
		color: #509EE3;
		margin-left: 5px;
	}
	.allComments {
		margin-top: 15px;
	}
</style>
